import React from "react";
// import Services from "../component/Services";
// import About from "../component/About";
import Contact from "../component/Contact";
import Footer from "../component/Footer";
// import Portfolio from "../component/Portfolio";
import Review from "../component/Testimonial";
// import Switcher from "../component/Switcher";
// import Process from "../component/Process";
import Header from "../component/Header";
// import Products from "../component/Products";
import Products1 from "../component/Products1";
import Cta1 from "../component/Cta1";
import Team from "../component/Team";


/**
 * Index Component
 */
export default function Index() {
  return (
    <>
      <div>
        <Header />
        {/* <About /> */}
        {/* <Process /> */}
        {/* <Services /> */}
        {/* <Portfolio /> */}
        {/* <Review /> */}
        {/* <Products /> */}
        <Products1 />
        {/* <Contact /> */}
        <Team />

        <Cta1 />
        <Footer />
        {/* <Switcher /> */}
      </div>
    </>
  );

}

